import React, { Component } from 'react';
import {
  CssBaseline,
  Grid,
  // makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow as MaterialTableRow,
  Typography,
  withStyles,
} from '@material-ui/core';

import cloneDeep from 'lodash/cloneDeep';
import axiosInstance, { WEB_API, getEventId } from '../../constatns';
import AdminTopbar from '../AdminTopbar';
import AdminFooter from '../AdminFooter';
import { CountryList } from '../../common/CountryList';
import SubTitle from '../../components/Text/SubTitle';
import Table from '../../components/Table/Table';

const styles = (theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      // minWidth: 100,
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
    '& > div:not(:first-child)': {
      marginBottom: '30px',
    },
  },
  subTitle: {
    fontSize: '1.2em',
    fontWeight: 600,
    paddingLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});

const TableRow = withStyles((theme) => ({
  root: {
    '& > th:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
    '& > td:not(:last-of-type)': {
      borderRight: '1px solid rgba(224, 224, 224, 0.5)',
    },
  },
}))(MaterialTableRow);

class RegistrationStatusTemp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: { total: 0, korean: 0, international: 0 },
      byRegstration: { r1: 0, r2: 0, r3: 0 },
      byPayment: { creditCard: 0, bankTransfer: 0, isFree: 0 },
      byMemberKind: {
        private: 0,
        trainee: 0,
        general: 0,
        opening: 0,
        surgeon: 0,
        resident: 0,
        foreigner: 0,
        partner: 0,
        etc: 0,
      },
      byCountry: [],
      byCategory: {
        overseaCategory1: 0, // KSPRS International Member
        overseaCategory2: 0, // KSPRS Global Partners-MOU Country (ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS)
        overseaCategory3: 0, // Guest Physicians
        overseaCategory4: 0, // International Trainee
        overseaCategory5: 0, // Invited Speaker
        krCategory1: 0, // 전문의
        krCategory2: 0, // 군의관・공보의
        krCategory3: 0, // 전공의
        krCategory4: 0, // 국내연수 외국인의사
        krCategory5: 0, // 동반자
        krCategory6: 0, // 무료등록
        krCategory7: 0, // 카테고리없음
        krCategory8: 0, // 외부연자
      },
    };

    // 전문의, 전공의, 원로회원·기부자·만 70세이상 정회원, 동반자,
  }

  componentDidMount() {
    this.init();
  }

  init() {
    axiosInstance.get(`${WEB_API}/user/list?eventId=${getEventId()}&limit=-1`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      /*
          // 등록자(isPay 값이 R)만 확인
          for (let item of response.data.Items) {
            if (item.isPay === 'R') {
              console.log(item);
            }
          }
        */
      // console.log('register', response.data);
      //   this.getCountData(response.data.Items);
      //   this.getMemberData(response.data.Items);
      //   this.getPaymentData(response.data.Items);
      //   this.getRegistrationType(response.data.Items);
      //   this.getCategoryData(response.data.Items);
      //   this.getCountryData(response.data.Items);
      this.getData(response.data.Items);
    });
  }

  getData = async (d) => {
    // let countTemp = cloneDeep(this.state.count);
    // let countryTemp = [];
    // let regTemp = cloneDeep(this.state.byRegstration);
    // let payTemp = cloneDeep(this.state.byPayment);
    // let memberTemp = cloneDeep(this.state.byMemberKind);
    // let categoryTemp = cloneDeep(this.state.byCategory);

    // d.map((item) => {
    //     if (item.isPay === 'R') {
    //       countTemp['total'] += 1;
    //       if (item.country === 'Korea, Republic of') countTemp['korean'] += 1;
    //       else countTemp['international'] += 1;

    //       if (d[i].regType) {

    //       }
    //     }
    //   });
    let countTemp = this.getCountData(d);
    let countryTemp = this.getCountryData(d);
    let regTemp = this.getRegistrationType(d);
    let payTemp = this.getPaymentData(d);
    let memberTemp = this.getMemberData(d);
    let categoryTemp = this.getCategoryData(d);

    await this.setState((prev) => ({
      count: countTemp,
      byCountry: countryTemp,
      byRegstration: regTemp,
      byPayment: payTemp,
      byMemberKind: memberTemp,
      byCategory: categoryTemp,
    }));
  };

  // 총 등록자 수
  getCountData(d) {
    let buff = cloneDeep(this.state.count);
    //eslint-disable-next-line
    d.map((item) => {
      if (item.isPay === 'R') {
        // this.setState((prevState) => ({
        //   ...count,
        //   total: prevState['total'] + 1,
        //   korean: item.country === 'Korea, Republic of' ? prevState['korean'] + 1 : prevState['korean'],
        //   international: item.country !== 'Korea, Republic of' ? prevState['international'] + 1 : prevState['international'],
        // }));
        buff['total'] += 1;
        if (item.country === 'Korea, Republic of') buff['korean'] += 1;
        else buff['international'] += 1;
      }
    });
    console.log(d);
    console.log(buff);
    // this.setState((prev) => ({ count: buff }));
    return buff;
  }

  // 국가별
  getCountryData(d) {
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
    }

    if (d) {
      for (let i = 0; i < d.length; i++) {
        if (d[i].isPay === 'R') {
          for (let j = 0; j < buff.length; j++) {
            if (buff[j].name === d[i].country) {
              // if (buff[j].name.indexOf(d[i].country) !== -1) {
              buff[j].count += 1;
            }
          }
        }
      }
    }

    return buff;
    // this.setState({ byCountry: buff });
  }

  // 등록구분별
  getRegistrationType(d) {
    let buff = cloneDeep(this.state.byRegstration);
    for (let i = 0; i < d.length; i++) {
      if (d[i].isPay === 'R' && d[i].regType) {
        // setByRegistration((prev) => ({
        //   r1: d[i].regType === 'R1' ? prev['r1'] + 1 : prev['r1'],
        //   r2: d[i].regType === 'R2' ? prev['r2'] + 1 : prev['r2'],
        //   r3: d[i].regType === 'R3' ? prev['r3'] + 1 : prev['r3'],
        // }));
        if (d[i].regType === 'R1') buff['r1'] += 1;
        if (d[i].regType === 'R2') buff['r2'] += 1;
        if (d[i].regType === 'R3') buff['r3'] += 1;
      }
    }
    return buff;
    // this.setState({
    //   byRegstration: buff,
    // });
  }

  // 결제수단별
  getPaymentData(d) {
    let buff = cloneDeep(this.state.byPayment);
    for (let i = 0; i < d.length; i++) {
      if (d[i].isPay === 'R') {
        // setByPayment((prevState) => ({
        //   ...byPayment,
        //   creditCard: d[i].payType === 'card' ? prevState['creditCard'] + 1 : prevState['creditCard'],
        //   bankTransfer: d[i].payType === 'bank' ? prevState['bankTransfer'] + 1 : prevState['bankTransfer'],
        //   isFree: d[i].payType === '무료등록' ? prevState['isFree'] + 1 : prevState['isFree'],
        // }));
        if (d[i].payType === 'card') buff['creditCard'] += 1;
        if (d[i].payType === 'bank') buff['bankTransfer'] += 1;
        if (d[i].payType === '무료등록') buff['isFree'] += 1;
      }
    }
    return buff;
    // this.setState({
    //   byPayment: buff,
    // });
  }

  // 회원구분별
  getMemberData(d) {
    let buff = cloneDeep(this.state.byMemberKind);
    //개인병원, 수련병원, 기타종합병원, 개원의, 군의관, 전공의, 외국인, 기타
    //eslint-disable-next-line
    d.map((item) => {
      if (item.isPay === 'R') {
        if (item.kind === '개인병원_봉직의') buff['private'] += 1;
        if (item.kind === '수련병원_봉직의') buff['trainee'] += 1;
        if (item.kind === '기타종합병원_봉직의') buff['general'] += 1;
        if (item.kind === '개원의') buff['opening'] += 1;
        if (item.kind === '군의관_공보의') buff['surgeon'] += 1;
        if (item.kind === '전공의') buff['resident'] += 1;
        if (item.kind === '국내연수 외국인의사') buff['foreigner'] += 1;
        if (item.kind === '동반자') buff['partner'] += 1;
        // if (item.kind === '기타') buff['etc'] += 1;
      }
    });
    return buff;
    // this.setState({ byMemberKind: buff });
  }

  // 카테고리별
  getCategoryData(d) {
    let buff = cloneDeep(this.state.byCategory);
    // let cnt = 0;
    //등록자만
    for (let item of d) {
      if (item.isPay === 'R') {
        console.log(item.username, item.cate1);
        // if (item.cate1) cnt += 1;
        if (item.cate1 === 'KSPRS International Member') buff['overseaCategory1'] += 1;
        if (item.cate1 === 'KSPRS Global Partners-MOU Country (ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS) ')
          buff['overseaCategory2'] += 1;
        if (item.cate1 === 'Guest Physicians') buff['overseaCategory3'] += 1;
        if (item.cate1 === 'International Trainee') buff['overseaCategory4'] += 1;
        if (item.cate1 === 'Invited Speaker') buff['overseaCategory5'] += 1;
        if (item.cate1 === '전문의') buff['krCategory1'] += 1;
        if (item.cate1 === '군의관・공보의') buff['krCategory2'] += 1;
        if (item.cate1 === '전공의') buff['krCategory3'] += 1;
        if (item.cate1 === '국내연수 외국인의사') buff['krCategory4'] += 1;
        if (item.cate1 === '동반자') buff['krCategory5'] += 1;
        if (item.cate1 === '무료등록' || item.cate1 === '원로회원·기부자·만 70세이상 정회원') buff['krCategory6'] += 1;
        if (item.cate1 === '외부연자') buff['krCategory8'] += 1;
        if (!item.cate1) buff['krCategory7'] += 1;
      }
    }

    // console.log(cnt);
    // console.log(this.state.byCategory);
    // console.log(buff);

    return buff;
    // this.setState({ byCategory: buff });
  }

  // 총 등록자 수 통계 테이블 렌더링
  renderCountChart() {
    const { count } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>총합계</TableCell>
            <TableCell>국내</TableCell>
            <TableCell>국외</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{count['total']}</TableCell>
            <TableCell>{count['korean']}</TableCell>
            <TableCell>{count['international']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  // 등록구분별 통계 테이블 렌더링
  renderRegistrationTypeChart() {
    const { byRegstration } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Early-Bird</TableCell>
            <TableCell>Regular</TableCell>
            <TableCell>On-site</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{byRegstration['r1']}</TableCell>
            <TableCell>{byRegstration['r2']}</TableCell>
            <TableCell>{byRegstration['r3']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  // 결제수단별 통계 테이블 렌더링
  renderPaymentChart() {
    const { byPayment } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Credit Card</TableCell>
            <TableCell>Bank Transfer</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{byPayment['creditCard']}</TableCell>
            <TableCell>{byPayment['bankTransfer']}</TableCell>
            <TableCell>{byPayment['isFree']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  // 회원구분별 통계 테이블 렌더링
  renderMemberKindChart() {
    const { byMemberKind } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>개인병원 봉직의</TableCell>
            <TableCell>수련병원 봉직의</TableCell>
            <TableCell>기타종합병원 봉직의</TableCell>
            <TableCell>개원의</TableCell>
            <TableCell>군의관, 공보의</TableCell>
            <TableCell>전공의</TableCell>
            <TableCell>국내연수 외국인의사</TableCell>
            <TableCell>동반자</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>{byMemberKind['private']}</TableCell>
            <TableCell>{byMemberKind['trainee']}</TableCell>
            <TableCell>{byMemberKind['general']}</TableCell>
            <TableCell>{byMemberKind['opening']}</TableCell>
            <TableCell>{byMemberKind['surgeon']}</TableCell>
            <TableCell>{byMemberKind['resident']}</TableCell>
            <TableCell>{byMemberKind['foreigner']}</TableCell>
            <TableCell>{byMemberKind['partner']}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  // 카테고리별 통계 테이블 렌더링
  renderCountCategoryChart() {
    const { classes } = this.props;
    const { byCategory } = this.state;
    return (
      <>
        <Typography className={classes.subTitle}>해외</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>KSPRS International Member</TableCell>
              <TableCell>KSPRS Global Partners-MOU Country (ASPS, JSPRS, TSPS, CSPS, ThPRS, InaPRAS, TSPRAS)</TableCell>
              <TableCell>Guest Physicians</TableCell>
              <TableCell>International Trainee</TableCell>
              <TableCell>Invited Speaker</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{byCategory['overseaCategory1']}</TableCell>
              <TableCell>{byCategory['overseaCategory2']}</TableCell>
              <TableCell>{byCategory['overseaCategory3']}</TableCell>
              <TableCell>{byCategory['overseaCategory4']}</TableCell>
              <TableCell>{byCategory['overseaCategory5']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Typography className={classes.subTitle} mt={1}>
          국내
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>개원의</TableCell>
              <TableCell>봉직의・전임의</TableCell>
              <TableCell>군의관・공보의</TableCell>
              <TableCell>전공의・국내연수 외국인의사</TableCell>
              <TableCell>동반자</TableCell>
              <TableCell>무료등록</TableCell>
              <TableCell>항목없음</TableCell>
              <TableCell>외부연자</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{byCategory['krCategory1']}</TableCell>
              <TableCell>{byCategory['krCategory2']}</TableCell>
              <TableCell>{byCategory['krCategory3']}</TableCell>
              <TableCell>{byCategory['krCategory4']}</TableCell>
              <TableCell>{byCategory['krCategory5']}</TableCell>
              <TableCell>{byCategory['krCategory6']}</TableCell>
              <TableCell>{byCategory['krCategory7']}</TableCell>
              <TableCell>{byCategory['krCategory8']}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }

  // 국가별 통계 테이블 렌더링
  renderCountryChart() {
    const { byCountry } = this.state;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>국가</TableCell>
            <TableCell>인원</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {byCountry &&
            byCountry.map(
              (country) =>
                country.count > 0 && (
                  <TableRow key={country.name}>
                    <TableCell>{country.name}</TableCell>
                    <TableCell>{country.count}</TableCell>
                  </TableRow>
                ),
            )}
        </TableBody>
      </Table>
    );
  }

  render() {
    const { classes } = this.props;
    const { isLoading, count, byPayment, byMemberKind, byCategory, byCountry } = this.state;
    return (
      <Grid item xs={12} style={isLoading ? { position: 'relative' } : {}}>
        <CssBaseline />
        <AdminTopbar MIdx={6} SIdx={0} />
        <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
          <Grid item>
            <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
              <Grid item>
                <h1>Status - Registration</h1>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>총 등록자 수</SubTitle>
            {count && this.renderCountChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>등록구분별 통계</SubTitle>
            {count && this.renderRegistrationTypeChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>결제수단별 통계</SubTitle>
            {byPayment && this.renderPaymentChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>회원구분별 통계 (국내)</SubTitle>
            {byMemberKind && this.renderMemberKindChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>카테고리별 통계</SubTitle>
            {byCategory && this.renderCountCategoryChart()}
          </Grid>
          <Grid item>
            <SubTitle isDecoHidden={true}>국가별 통계</SubTitle>
            {byCountry && this.renderCountryChart()}
          </Grid>
        </Grid>
        <AdminFooter />
      </Grid>
    );
  }
}

export default withStyles(styles, { withTheme: true })(RegistrationStatusTemp);
